/*
 * @file: constants.js
 * @description: It contain constants used in application.
 */

/*
 * @pagination: constants used in Pagination
 */
export const pagination = {
  page: 1,
  limit: 8,
  maxlimit: 1000,
  scrollLimit: 8,
  docLimit: 10
};

export const toasterConfig = {
  autoClose: 3000,
  hideProgressBar: true
}
export const PLAN_LIMITS = { free: 2, basic: 10, popular: 20, platinum: 30 }
/*
 * @fileType: constants used for filetypes
 */
export const fileType = {
  ZIP: "application/zip,application/x-zip-compressed,multipart/x-zip,.zip",
  PDF: "application/pdf",
  IMAGE: "image/*"
};
export const errorCode = {
  '100': "Unknown document processing error",
  '101': "Missing required value",
  '102': "Multiple values not supported",
  '103': "Field not found.  Check configuration.",
  '104': "Document validation failed",
  '105': "Missing Loan Number",
  '106': "Potential mismatach",
  '107': "Validation Error"
};

// export const errorCodeLogs = {
// '100': "Unknown document processing error",
// '101': "Field Validation",
// '102': "Multiple values not supported",
// '103': "Field not found.  Check configuration.",
// '104': "Document validation failed",
// '105': "Document Validation",
// '106': "Potential mismatach",
// '107': "Validation Error"
// };


export const documentType = {
  'purchase_advice': "Purchase Advice",
  'drivers_license': "Drivers License",
  'home_owners_insurance': "Home Owners Insurance",
  'w2': "W2",
  'check': "Check",
  'flood_cert': "Flood Cert",
  'paystub': "Paystub",
  'bank_statement': "Bank Statement",
  'purchase_agreement': "Purchase Agreement",
  'final_document': "Final Document",
};

export const documentFilterItems = [
  { is_correct: 1, is_verified: 2, label: 'CG VR', correct: 'bg-success', verified: 'bg-danger' },
  { is_correct: 2, is_verified: 1, label: 'CR VG', correct: 'bg-danger', verified: 'bg-success' },
  { is_correct: 1, is_verified: 1, label: 'CG VG', correct: 'bg-success', verified: 'bg-success' },
  { is_correct: 2, is_verified: 2, label: 'CR VR', correct: 'bg-danger', verified: 'bg-danger' },
  { is_correct: 2, is_verified: 2, label: 'CR OR VR', correct: 'bg-danger', verified: 'bg-danger' },
  { record_active: false, label: 'Archived' },
  // { allDocumentsAllActionCompleted: true, label: 'Completed' }
]

export const documentViewFilterItems = [
  { is_correct: 1, is_verified: 2, label: 'CG VR', correct: 'bg-success', verified: 'bg-danger' },
  { is_correct: 2, is_verified: 1, label: 'CR VG', correct: 'bg-danger', verified: 'bg-success' },
  { is_correct: 1, is_verified: 1, label: 'CG VG', correct: 'bg-success', verified: 'bg-success' },
  { is_correct: 2, is_verified: 2, label: 'CR VR', correct: 'bg-danger', verified: 'bg-danger' }
]


export const incomeAnalyzerFilterItems = [
  { status: 'false', label: 'Pending' },
  /* { status:'Rejected',label: 'Rejected'},*/
  { status: 'true', label: 'Ready' },
]



export const analyzerFilterItems = [
  { status: 'Pending', label: 'Pending' },
  { status: 'Ready', label: 'Ready' }
]




/*
 * @process: used to define different stages in file process
 */
export const processes = [
  "Extracting...",
  "Reading...",
  "Analyzing...",
  "Logical inference...",
  "Validating...",
  "Success",
];

/*
 * @maxScaleValue: used to define maximum pdf scale size
 */

export const maxScaleValue = 5;
export const scaleIncrement = 0.10;

export const maxLoadTime = 60;

export const intervalTime = 1000; //every 1 second


export const Packets = "Packets";
export const statusOptions = [
  { value: false, label: 'Active' },
  { value: true, label: 'Archived' }
]

export const documentStatusOptions = [
  { value: false, label: 'Active' },
  { value: true, label: 'Archived' },
  { value: 'unable_to_validate', label: 'Unable To Validate' }
]

export const queueOptions = [
  { value: '4', label: 'In-Queue' },
  { value: '0', label: 'All' },
  { value: '5', label: 'Processed' },
  { value: 'deleted', label: 'Deleted' },
  { value: 'error', label: 'Error' }

]

export const roleItems = ["admin", "operator", "business", "superadmin", "subadmin"];

export const roleTypes = ["admin", "business"]

export const elasticSearchMaxLimit = 10;

export const REGEX = {
  NAME: /^[a-zA-Z\s]*$/,
  PASSWORD: /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
  PHONE: /^(\+\d{1,3}[- ]?)?\d{10}$/
}


export const monthNames = ['null', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const barGraphOptions = [
  { value: 'month', label: 'Monthly' },
  { value: 'quarter', label: 'Quarterly' },
  { value: 'year', label: 'Yearly' }
]

export const pieChartOptions = [
  { value: 'month', label: 'Current Month' },
  { value: 'year', label: 'Current Year' },
]
export const imageExtension = ['jpeg', 'jpg', 'png', 'JPEG', 'JPG', 'PNG'];

export const timeout = 1000 * 60 * 15; // 15 minutes (idle logout timeout)
// export const timeout = 1000 * 15; // 15   sec  (idle logout timeout)

export const maxConfidence = 0.987;

export const src = {
  fileUpload: 'file_upload',
  loc: 'LOC'
}
export const tagsLimit = 5;

export const clientEmail = 'MORiSupport@gettrained.ai';

export const ipAddress = {
  clientIP: '50.73.174.73',
  clientIP2: '192.168.1.230',
  clientIP3: '108.39.226.37',
  clientIP4: '96.236.148.78',
  clientIP5: '104.245.69.92',
  smartDataIP: '203.129.247.226',
  myIP: '223.233.77.182',
  clientIP6 : '192.168.86.30',
  clientIP7 : '169.254.52.24/16',
  clientIP8 : '100.6.6.120',
  clientIP9 : '100.0.169.234',
  clientIP10 : '71.142.120.124',
  clientIP11 : '68.83.95.199'
} 


